module.exports = __webpack_public_path__ + "static/media/dark.3ce49dcc.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/spinners/dark.gif
 ** module id = 2313
 ** module chunks = 50
 **/